import useAuth from './useAuth';

const useIsLOCadmin = () => {
  const auth = useAuth();
  const event = auth.user?.event;

  return auth.isAuthenticated && !!event;
};

export default useIsLOCadmin;
